// src/lib/app-data-ssc-data.ts
var appeals = "/appeals-manager";
var appeal = "/appeal";
var support = "/support";
var AppData = {
  filterTextAbridged: ` If there are too many rows in the list you can apply a filter by typing it in the 'search all appeals' input box. All columns (Benefit/Case Ref/Status/Appellant Names) in the table below will be searched.`,
  filterText: ` If there are too many rows in the list you can apply a filter by typing it in the 'search all appeals' input box. All columns in the table will be searched. 
  
  For example: If you want to show only 'Adult Disability Payment' cases then you can start typing 'Ad'. Because this filters on all columns this will also bring back cases with someone called Adam (in the 'Appellant Names' column) so typing 'Adult' might be more appropriate.  `,
  header: {
    headerText: "Social Security Chamber",
    menuItems: [
      { displayText: "Appeals", routeUri: appeals },
      { displayText: "Contact Us", routeUri: support }
    ],
    dropdownMenuItems: [
      {
        displayText: "Logout",
        routeUri: "",
        isHref: false,
        isCallback: true
      }
    ],
    dropdownMenuText: "Profile"
  },
  contact: {
    address: {
      addressType: "",
      building: "Scottish Courts and Tribunals Service",
      addressLine1: "Glasgow Tribunals Centre",
      addressLine2: "20 York Street",
      addressLine3: "",
      townCity: "Glasgow",
      country: "",
      postalCode: "G2 8GT"
    },
    orginisationName: "Social Security Chamber",
    email: "sscadmin@scotcourtstribunals.gov.uk",
    phone: "0141 302 5858",
    phoneText: `Mon - Thur: 9:00 am - 5:00 pm
    Fri:        9:00 am to 4:30 pm
    Sat & Sun:  Closed`,
    publicHolidayText: "The office is closed on public and privilege holidays. ",
    publicHolidayLink: "",
    complaints: [
      {
        name: "Compliments, suggestions or complaints",
        url: "https://www.socialsecuritychamber.scot/home/contact-us/compliments-suggestions-and-complaints"
      }
    ]
  },
  footer: {
    backgroundColour: "#105b7d",
    colour: "white",
    padding: "0.5rem",
    paddingBottom: "0.25rem",
    links: [
      {
        url: "https://www.socialsecuritychamber.scot/home/about-us/ssc-privacy-statement/freedom-of-information",
        name: "Freedom of Information",
        showIcon: true,
        external: true
      },
      {
        url: "https://www.socialsecuritychamber.scot/home/about-us/ssc-privacy-statement/",
        name: "Privacy",
        showIcon: true,
        external: true
      },
      {
        url: "/accessibility",
        name: "Accessibility",
        showIcon: false,
        external: false
      },
      {
        url: "https://www.socialsecuritychamber.scot/home/terms-and-conditions",
        name: "Terms & conditions",
        showIcon: true,
        external: true
      }
    ]
  },
  routes: {
    home: appeals,
    appeal,
    appeals,
    support
  },
  loader: {
    loadingText: "",
    blinkText: false,
    padding: "0.5rem"
  },
  notFound: {
    links: [
      {
        linkText: "Home page",
        linkRoute: "/",
        icon: "bi-house-fill"
      },
      {
        linkText: "Contact Us",
        linkRoute: "/support",
        icon: "bi-heart-pulse"
      },
      {
        linkText: "Appeals",
        linkRoute: "/appeals-manager",
        icon: "bi-clipboard-data"
      }
    ],
    padding: "1rem",
    margin: "1rem"
  },
  accessibility: {
    contactEmail: "sscadmin@scotcourtstribunals.gov.uk",
    complianceIssues: [
      `Some of our case file names may not be easy to read, therefore, it may not easy to understand the file's content based on this`
    ]
  }
};

// src/lib/app-data-ltc-data.ts
var AppDataLocalTax = {
  header: {
    headerText: "Local Taxation Chamber",
    headerTextMobile: "Local Taxation",
    menuItems: [
      { displayText: "Home", routeUri: "/" },
      { displayText: "About", routeUri: "/about" },
      { displayText: "FAQs", routeUri: "/faqs" },
      { displayText: "Legislation", routeUri: "/legislation" },
      { displayText: "Make an Appeal", routeUri: "/apply" },
      { displayText: "Appeals pre April 2023", routeUri: "/existing-appeals" },
      { displayText: "Decisions", routeUri: "/decisions" },
      { displayText: "Hearings", routeUri: "/hearings" },
      { displayText: "Contact", routeUri: "/contact-us" }
    ]
  },
  footer: {
    backgroundColour: "#105b7d",
    colour: "#fff",
    padding: "0.5rem",
    paddingBottom: "0.25rem",
    copyrightMessage: "Local Taxation Chamber"
  },
  loader: {
    loadingText: "",
    blinkText: false,
    padding: "0.5rem"
  },
  notFound: {
    links: [
      {
        linkText: "Home page",
        linkRoute: "/",
        icon: "bi-house-fill"
      },
      {
        linkText: "Contact Us",
        linkRoute: "/contact-us",
        icon: "bi-pencil-square"
      }
    ],
    padding: "1rem",
    margin: "1rem"
  },
  existingAppealTypes: {
    items: [
      {
        title: "Non-Domestic Rates Appeals",
        body: `The Assessor must notify the Local Taxation Chamber of the Appeal or complaint by 30th April 2023. Once the Local Taxation Chamber receive a note of the appeal or complaint from the Assessor they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`
      },
      {
        title: "Appeals against Council Tax Banding",
        body: `The Assessor must notify the Local Taxation Chamber of the Appeal by 30th April 2023. Once the Local Taxation Chamber receive a note of the appeal from the Assessor they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`
      },
      {
        title: "Council Tax Liability Appeals",
        body: `The Local Authority must notify the Local Taxation Chamber of the Appeal by 12th May 2023. Once the Local Taxation Chamber receive a note of the Appeal from the Local Authority they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`
      },
      {
        title: "Water Charges Appeals",
        body: `The Local Authority must notify the Local Taxation Chamber of the Appeal. Once the Local Taxation Chamber receive a note of the Appeal from the Local Authority they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`
      },
      {
        title: "Council Tax Reduction Appeals",
        body: `The Appeals already lodged with the Council Tax Reduction Review Panel will automatically transfer to the Local Taxation Chamber. Once the Local Taxation Chamber receive a note of the appeal from the Council Tax Reduction Review Panel they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number. `
      },
      {
        title: "Appeal against civil penalties imposed as a result of failure to comply with an Assessor Information Notice.",
        body: `The Assessor must notify the Local Taxation Chamber of the Appeal. Once the Local Taxation Chamber receive a note of the appeal from the Assessor they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`
      },
      {
        title: "Appeal against civil penalties imposed as a result of failure to comply with a Local Authority Information Notice.",
        body: `The Local Authority must notify the Local Taxation Chamber of the Appeal. Once the Local Taxation Chamber receive a note of the appeal from the Local Authority they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`
      }
    ],
    index: 1
  },
  contact: {
    address: {
      addressType: "",
      building: "First Floor, Bothwell House",
      addressLine1: "Hamilton Business Park",
      addressLine2: "Caird Park",
      addressLine3: "",
      townCity: "Hamilton",
      country: "",
      postalCode: "ML3 0QA"
    },
    orginisationName: "Local Taxation Chamber",
    email: "LTCAdmin@scotcourtstribunals.gov.uk",
    phone: "01698 390012",
    phoneText: `Mon - Thur: 9:00 am - 5:00 pm
    Fri:        9:00 am to 4:30 pm
    Sat & Sun:  Closed`,
    publicHolidayText: "The office is closed on public and privilege holidays, and office closure dates are posted. ",
    publicHolidayLink: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/public-priviledge-holidays.pdf",
    complaints: [
      {
        name: "Complaints against Tribunal Members and Judges ",
        url: "https://www.judiciary.scot/home/publications/judicial-complaints"
      },
      {
        name: "Complaints against Scottish Courts and Tribunal Service ",
        url: "http://www.scotcourts.gov.uk/complaints/complaints-and-feedback"
      },
      {
        name: "Complaints against Advocates and Solicitors ",
        url: "http://www.scottishlegalcomplaints.org.uk/"
      }
    ]
  },
  usefulLinksFooter1: {
    title: "Useful Links",
    links: [
      {
        name: "Tribunals User Charter",
        href: "https://www.scotcourts.gov.uk/media/xcmllz1h/214-tribunals-customer-charter-leaflet-v7-july-2024.pdf",
        external: true
      },
      {
        name: "COSLA",
        href: "https://www.cosla.gov.uk/",
        external: true
      },
      {
        name: "Shelter Scotland",
        href: "https://scotland.shelter.org.uk/",
        external: true
      }
    ]
  },
  usefulLinksFooter2: {
    title: "Tribunals User Charter",
    links: [
      {
        name: "Scottish Assessors Association",
        href: "https://www.saa.gov.uk/",
        external: true
      },
      {
        name: "Citizens Advice Scotland",
        href: "https://www.cas.org.uk/",
        external: true
      }
    ]
  },
  taxLinks1: {
    title: "Local Taxation Chamber Links",
    links: [
      {
        href: "/reviews",
        name: "Appeal or Review Decision",
        external: false
      },
      {
        href: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/practice-directions.pdf",
        name: "Practice Directions",
        external: true
      },
      {
        href: "/foi",
        name: "Freedom of Information",
        external: false
      },
      {
        href: "/hearings",
        name: "Forthcoming Hearings",
        external: false
      }
    ]
  },
  taxLinks2: {
    title: " - ",
    links: [
      {
        href: "https://www.scotcourts.gov.uk/about-the-scottish-court-service/contact-us/data-protection",
        name: "Privacy",
        external: true
      },
      {
        href: "/accessibility",
        name: "Accessibility",
        external: false
      },
      {
        href: "/terms",
        name: "Terms & Conditions",
        external: false
      }
    ]
  },
  faqs: [
    {
      title: "What is the Local Taxation Chamber?",
      body: `The Tribunals (Scotland) Act 2014 created a new statutory framework for tribunals in Scotland.  The Act created two new tribunals, the First-tier Tribunal for Scotland and the Upper Tribunal for Scotland, known collectively as the Scottish Tribunals. The First-tier Tribunal consists of a number of Chambers, each with its own jurisdiction and headed by a Chamber President.
      The First-tier Tribunal for Scotland deals with first instance decisions. These are cases heard at a tribunal for the first time

      The current functions of the Valuation Appeals Committees and the Council Tax Reduction Review Panel will transfer to the new Local Taxation Chamber on 1st April 2023.
      `,
      section: "",
      links: [
        {
          url: "https://www.judiciary.scot/home/judiciary/judicial-office-holders/tribunals",
          text: "Learn more about Tribunals"
        },
        {
          url: "https://www.saa.gov.uk/non-domestic-valuation/the-valuation-roll/valuation-appeal-committee/",
          text: "Valuation Appeals Committee"
        },
        {
          url: "https://www.counciltaxreductionreview.scot/",
          text: "Council Tax Reduction Review Panel"
        }
      ]
    },
    {
      title: "Is this the same as the Tax Chamber?",
      body: `
      No.  The First-tier Tribunal for Scotland Tax Chamber decides appeals relating to Lands and Buildings Transaction Tax and Scottish Landfill Tax.      `,
      section: ""
    },
    {
      title: "When and how will the Local Taxation Chamber hear appeals?",
      body: `The majority of hearings will take place remotely via Webex. You will receive a link to log on to the hearing at the time it is scheduled to take place. Make sure you can connect to the hearing in good time, we suggest you join the hearing at least 5 minutes early. Once joined, you will be held in a waiting room (lobby) until the hearing can start. The clerk will admit you to the hearing at your given time. We recommend you wear a headset with a microphone, if possible as this helps with audio.`,
      section: ""
    },
    {
      title: "What if I don\u2019t have access to a computer or internet?",
      body: `The tribunal\u2019s normal way of working is to hold virtual hearings. The tribunal will only consider holding a face to face hearing, if it is satisfied that it would be impossible for it to dispense justice remotely. Any application for a face to face hearing must be supported by compelling reasons to justify a departure from the tribunal\u2019s normal way of working. `,
      section: ""
    },
    {
      title: "How will I find out the outcome of my appeal?",
      body: `When an appeal is decided at a hearing you may be told the decision orally at the hearing or advised in writing later.

      The Tribunal's written decision will be provided as soon as possible after the Tribunal have made their decision
      `,
      section: ""
    },
    {
      title: "Will the decisions be made public?",
      body: `Decisions (other than Council Tax Reduction decisions) will be published on this website`,
      section: "",
      links: [
        {
          url: "/decisions",
          text: "Go to decisions page"
        }
      ]
    },
    {
      title: "Is there a fee for lodging an appeal?",
      body: `There is no fee for lodging an appeal with the Local Taxation Chamber. A fee will have to be paid for Non-domestic rates referrals to the Upper Tribunal. `,
      section: ""
    },
    {
      title: "How do I make a complaint?",
      body: `Information on how to make a complaint is available on the Contact page `,
      section: "",
      links: [
        {
          url: "/contact-us",
          text: "Go to contact page"
        }
      ]
    },
    {
      title: "Who are the members of the Local Taxation Chamber?",
      body: `Information on Members is available via the About page on this website`,
      section: "",
      links: [
        {
          url: "/about",
          text: "Go to about page"
        }
      ]
    }
  ],
  appealTypesCt: {
    items: [
      {
        id: "ct-banding",
        title: "Appeals against Council Tax Banding",
        body: `The Scottish Assessors are responsible for maintaining the council tax valuation list, which contains
        information relating to each domestic property in a local authority area. 
        
        The Chamber will hear appeals regarding entries made by Assessors to the valuation list of domestic properties`,
        links: [
          {
            text: "Notes on completing Form C-4b",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C-4b (Proposal Not well founded) NOTES.pdf"
          },
          {
            text: "Notice of Appeal Form C-4b",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C-4b (Proposal Not well founded).pdf"
          }
        ],
        processFlow: []
      },
      {
        id: "ct-invalid",
        title: "Invalid Council Tax Banding Appeals",
        body: `Council tax Banding Proposals must be sent to the Assessor within 6 months of the date that you first become liable to pay council tax for the Property. If you sent your Proposal to the Assessor more than six months after this date the Assessor will find that the Proposal is invalid. The Assessor will send you a Notice advising that the Proposal was invalid. The Assessor may also determine that Proposals are invalid due to lack of title or lack of information. `,
        links: [
          {
            text: "Notes on completing Form C-4a",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C-4a (Proposal Invalid) NOTES.pdf"
          },
          {
            text: "Notice of Appeal Form C-4a",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C-4a (Proposal Invalid).pdf"
          }
        ],
        processFlow: []
      },
      {
        id: "ct-liability",
        title: "Council Tax Liability Appeals (Calculation of Council Tax Liability, Exemptions and Discounts)",
        body: `The Chamber will also hear other council tax appeals such as the calculation of council tax liability, exemptions and discounts.`,
        links: [
          {
            text: "Notes on completing Form C1",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C1 (liability)NOTES.pdf"
          },
          {
            text: "Notice of Appeal Form C1",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C1 (liability).pdf"
          }
        ],
        processFlow: []
      },
      {
        id: "ct-reduction",
        title: "Council Tax Reduction Appeals",
        body: `The Council Tax Reduction Review Panel (CTRRP) was established to hear appeals against how a local
        authority has calculated someone\u2019s level of Council Tax Reduction. It provides an additional review function, beyond that provided by the relevant local authority and safeguards an individual\u2019s right to administrative justice in relation to the Council Tax Reduction scheme. The functions of the CTRRP will transfer to the Chamber. `,
        links: [
          {
            text: "Notes on completing Form D",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM D (Reduction Review) NOTES.pdf"
          },
          {
            text: "Notice of Appeal Form D",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM D (Reduction Review).pdf"
          }
        ],
        processFlow: []
      },
      {
        id: "ct-completion",
        title: "Council Tax Completion Notice Appeals",
        body: `Completion Notices for new buildings are issued by the Assessor. The Completion Notice details the date erection of the Property is to be treated as completed.  The Chamber will hear Completion Notice appeals.`,
        links: [
          {
            text: "Notes on completing Form C3",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C3 (Completion Notice)NOTES.pdf"
          },
          {
            text: "Notice of Appeal Form C3",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C3 (Completion Notice).pdf"
          }
        ],
        processFlow: []
      },
      {
        id: "ct-penalty",
        title: "Council Tax Penalty Notice Appeals",
        body: `The Chamber will also hear Council Tax Penalty Notice appeals.`,
        links: [
          {
            text: "Notes on completing Form C2",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C2 (Council Tax Penalty)(NOTES).pdf"
          },
          {
            text: "Notice of Appeal Form C2",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C2 (Council Tax Penalty).pdf"
          }
        ],
        processFlow: []
      }
    ],
    index: 1
  },
  appealTypesNdr: {
    items: [
      {
        id: "ndr-appeal",
        title: "Non-Domestic Rates Appeals",
        body: `The Assessors are responsible for maintaining the Valuation Roll which lists each non-domestic property in a local authority area and gives their Net Annual Value and Rateable Value. 
        
        The Non-Domestic Rates (Scotland) Act 2020 introduced a two stage appeal system. If you don\u2019t agree with an entry in the Valuation Roll you must first send the Assessor a Proposal which advises the Assessor of the Valuation Roll entry that you consider to be incorrect. 
        
        The Assessor will issue a Proposal Determination Date and issue their decision on or before the Proposal Determination Date.
        
        The Assessor may decide to alter the entry in the Valuation Roll in accordance with the Proposal. Alternatively the Assessor may decide not to alter the entry in the Valuation Roll or may alter the entry other than in accordance with the Proposal. If you do not agree with Assessor\u2019s refusal to amend the entry in the Valuation Roll or if you do not agree with the amended entry you can appeal to the Local Taxation Chamber.  

        In complex or highly technical appeals applications can be made to the Tribunal for an appeal to be referred to the Upper Tribunal. If the Tribunal has decided not to refer an appeal to the Upper Tribunal an appeal against that decision can be lodged direct with the Upper Tribunal.`,
        links: [
          {
            text: "Notes on completing Form A",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM A (NDR)NOTES.pdf"
          },
          {
            text: "Notice of Appeal Form A",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM A (NDR).pdf"
          }
        ],
        processFlow: []
      },
      {
        id: "ndr-complaint",
        title: "Non-Domestic Rates Complaints",
        body: `The Assessors are responsible for maintaining the Valuation Roll which lists each non-domestic property in a local authority area and gives their Net Annual Value and Rateable Value. A complaint to the Local Taxation Chamber can be made about an entry in the Valuation Roll if you have interest but are not the proprietor, tenant or occupier of the property concerned.`,
        links: [
          {
            text: "Notes on completing Form B(23)",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM B(23) (NDR Complaint) NOTES.pdf"
          },
          {
            text: "Notice of Complaint Form B(23)",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM B(23) (NDR Complaint).pdf"
          }
        ],
        processFlow: []
      },
      {
        id: "ndr-penalty",
        title: "Non-Domestic Rates Penalty Notice Appeals",
        body: `The Chamber will also hear Non-Domestic Rates Penalty Notice appeals. `,
        links: [
          {
            text: "Notes on completing Form E",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM E (NDR Penalty) NOTES.pdf"
          },
          {
            text: "Notice of Appeal Form E",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM E (NDR Penalty).pdf"
          }
        ],
        processFlow: []
      }
    ]
  },
  observersGovernance: {
    name: "guidance for hearing observers",
    href: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Guidance for Observers.pdf",
    external: true
  },
  takingOfOralEvidence: {
    name: "taking of oral evidence from persons located overseas in tribunal proceedings",
    href: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Taking of oral evidence from persons located overseas.pdf"
  },
  appealTypesWater: {
    items: [
      {
        id: "ct-water",
        title: "Water Charges Appeals",
        body: `The Chamber will hear appeals against a Local Authority decision that water charges are payable or the calculation of water charges liability.`,
        links: [
          {
            text: "Notes on completing Form C5",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C5(Water Charges)NOTES.pdf"
          },
          {
            text: "Notice of Appeal Form C5",
            url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C5(Water Charges).pdf"
          }
        ],
        processFlow: []
      }
    ]
  },
  reviewFaqs: [
    {
      title: "What if a party wishes to appeal a Non-Domestic Rates Decision ?",
      body: `Non-Domestic Rates decisions made by the Tribunal are appealed to the Lands Valuation Appeal Court by stated case. 
      
      The appeal procedure is regulated by Act of Sederunt (Valuation Appeal Rules Amendment) 1982, as amended.
      
      The Appellant must lodge their grounds of appeal with the Tribunal within 14 days of the date on which the Tribunal decision was issued to them. At the same time a copy must be provided to the opposite party who has 14 days to lodge answers to the grounds of appeal with the Tribunal. 
      
      Within six weeks after the appellant has lodged their grounds of appeal the Tribunal shall issue the draft stated case to the appellant and the respondent. 
      
      Within four weeks of the date the draft stated case has been issued to the parties either party may make revisals and provide them to the Tribunal. 
      
      Objections to the revisals may be lodged with the Tribunal within two weeks.
      
      The Tribunal must lodge the signed stated case with the Lands Valuation Appeal Court within 14 days of the last date on which revisals may be made
      `,
      section: "",
      listItems: []
    },
    {
      title: "What if a party wishes to appeal a Council Tax Decision ?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "An application for permission to appeal must be made in writing to the First-tier Tribunal",
          subList: []
        },
        {
          listItem: "The application must",
          subList: [
            "Identify the decision to which the application for permission relates",
            "Identify the point or points of law on which the applicant wishes to appeal",
            "State the result the applicant is seeking"
          ]
        },
        {
          listItem: "Permission must be sought within 30 days -  ie the application for permission must be received within 30 days of:",
          subList: [
            "The decision being appealed against being sent to the appellant OR",
            "if later, a statement of reasons being sent to the appellant OR",
            "the date of the hearing at which the decision was given orally  - unless written reasons were requested (within 14 days of the hearing), and the Tribunal undertook to provide them, in which case within 30 days of the date they were sent"
          ]
        },
        {
          listItem: "The First-tier Tribunal for Scotland has power to extend the time for requesting permission to appeal \u201Con cause shown\u201D",
          subList: []
        }
      ]
    },
    {
      title: "What is a \u201CPoint of Law\u201D?",
      body: `\u201CThe Inner House of the Court of Session in the case of Advocate General for Scotland v Murray Group Holdings Limited (2015) CSIH 77 identified four different categories of case covered by the concept of an appeal upon a point of law: these are 

      (i) an error of general law, the content of its rules; 
      (ii) an error in the application of the law to the facts; 
      (iii) making findings in fact without a basis in the evidence; and 
      (iv) taking a wrong approach to the case by, for example, asking the wrong questions or taking account of manifestly irrelevant considerations, or by arriving at a decision that no reasonable tribunal can properly reach.\u201D
 
      Per DECISION NOTICE OF SHERIFF I FLEMING in the case of ABDUL MAJID and ADELE GAFFNEY AND ANDREW ROBERT BRITTON [2019] UT 59
      `,
      section: "",
      listItems: []
    },
    {
      title: "Which decisions may be appealed?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "Any decision that is not an excluded decision in terms of the Tribunals (Scotland) Act 2014 (see Section 46(5)).",
          subList: []
        },
        {
          listItem: "A refusal of permission to appeal is not reviewable OR appealable (Section 55(2) of the Tribunals (Scotland) Act 2014).",
          subList: []
        },
        {
          listItem: "A decision in a review (being the decision to set aside, take no action, or correct a minor or accidental error) is not reviewable OR appealable (Section 52 of the Tribunals (Scotland) Act 2014)",
          subList: []
        }
      ]
    },
    {
      title: "What decision can the First-tier Tribunal for Scotland make?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "Permission to appeal may be granted by the First-tier Tribunal for Scotland (Housing and Property Chamber), or",
          subList: []
        },
        {
          listItem: "Permission may be granted in part, or",
          subList: []
        },
        {
          listItem: "Permission may be refused",
          subList: []
        }
      ]
    },
    {
      title: "What if Permission to Appeal is granted by the First-tier Tribunal for Scotland?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "The appellant may then submit an appeal to the Upper Tribunal for Scotland",
          subList: []
        }
      ]
    },
    {
      title: "What if Permission to Appeal is refused by the First-tier Tribunal for Scotland?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "The decision is not reviewable or appealable",
          subList: []
        },
        {
          listItem: "If permission is refused, the appellant may then seek permission to appeal from the Upper Tribunal for Scotland",
          subList: []
        }
      ]
    },
    {
      title: "What if Permission to Appeal is granted in part by the First-tier Tribunal for Scotland?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "The decision is not reviewable or appealable",
          subList: []
        },
        {
          listItem: "The appellant must decide whether to",
          subList: [
            "apply to the Upper Tribunal for Scotland for permission to appeal the points that were not granted by the First-tier Tribunal for Scotland, or",
            "submit an appeal to the Upper Tribunal for Scotland to determine only the points that were granted by the First-tier Tribunal for Scotland"
          ]
        }
      ]
    },
    {
      title: "What is the timescale for applying to the Upper Tribunal?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "The application must be made within 30 days of the date on which the grant or refusal of permission was sent to the appellant",
          subList: []
        },
        {
          listItem: "The 30 day period can be extended by the Upper Tribunal \u201Con cause shown\u201D.",
          subList: []
        }
      ]
    },
    {
      title: "What is \u201CReview\u201D?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "This is where both the First-tier Tribunal for Scotland (Local Taxation Chamber) and the Upper Tribunal for Scotland have the power to review their own decisions.",
          subList: []
        }
      ]
    },
    {
      title: "How is a Review triggered?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "The relevant tribunal may decide at its own instance decide to review a decision or a party to the case can ask it to do so.",
          subList: []
        }
      ]
    },
    {
      title: "On what basis can the tribunal review its decision?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "If, in the interests of justice, it considers it is necessary to do so.",
          subList: []
        }
      ]
    },
    {
      title: "Which decisions may be reviewed?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "Any decision that is not an excluded decision in terms of the Tribunals (Scotland) Act 2014 (see Section 43(3))",
          subList: []
        },
        {
          listItem: "A decision on a Non-Domestic Rates Appeal cannot be reviewed ( Rule 19(2) The First tier Tribunal for Scotland Local Taxation Chamber (Rules of Procedure) Regulations 2022).",
          subList: []
        },
        {
          listItem: "A refusal of permission to appeal is not reviewable OR appealable (Section 55(2) of the Tribunals (Scotland) Act 2014).",
          subList: []
        },
        {
          listItem: "A decision in a review (being the decision to set aside, take no action, or correct a minor or accidental error) is not reviewable OR appealable (Section 52 of the Tribunals (Scotland) Act 2014)",
          subList: []
        }
      ]
    },
    {
      title: "What time limits apply to reviews?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "An application for review by a party must be sought within 14 days -  i.e. the application for review must be received by the First-tier Tribunal for Scotland within 14 days of:",
          subList: [
            "the decision being made  OR",
            "if later, the written statement of reasons being sent to the parties."
          ]
        }
      ]
    },
    {
      title: "What is the procedure for a review?",
      body: ``,
      section: "",
      listItems: [
        {
          listItem: "The application for review must be in writing and must state why a review is necessary. The party seeking a review must send a copy of the application for review to all other parties.",
          subList: []
        },
        {
          listItem: "If the tribunal revise the decision and statement of reasons following review, either at the request of a party or on its own initiative, the revised decision is treated as a fresh decision and there is a period of 14 days from the issue of the revised decision for seeking a review, and a period of 30 days from the issue of the revised decision for seeking permission to appeal.",
          subList: []
        },
        {
          listItem: "If the decision and statement of reasons are not revised, the 30 days for seeking permission to appeal runs from the date of issue of the original decision, and the decision cannot be reviewed again.",
          subList: []
        }
      ]
    }
  ],
  accessibility: {
    contactEmail: "LTCAdmin@scotcourtstribunals.gov.uk",
    complianceIssues: [
      `Our downloadable application forms are currently not completely accessibile when using screen reader software. If you have issues when trying to access these forms, please contact the Local Taxation Chamber using the further contact details on our "Contact" page.`,
      `On some mobiles our downloadable forms may require specific software to be installed, from the app store, to enable edit capabilities. Search for 'Edit PDF' `
    ],
    additionalItems: [
      {
        title: "Hearing Accessibility Form",
        body: "If you have any specific requirements for attendance at, and participation in, a Hearing of the Local Taxation Chamber then please complete the form below.",
        url: "https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Accessibility Form.pdf",
        urlName: "Download accessibility hearing form"
      }
    ]
  },
  terms: {
    disclaimer: `The inclusion of a link on this website does not constitute recommendation, endorsement, approval or support of said website or any part thereof by the Local Taxation Chamber (LTC), nor does it imply any responsibility on the part of the LTC for any information the website may contain.
    
    The LTC makes no warranty, either express or implied, as to the accuracy, availability or content of any information, data, text or graphics not under the  https://www.localtaxationchamber.scot domain. It has not tested any of the software located on the linked sites and does not make any representation as to the quality, safety, reliability or suitability of said software.
    
    The LTC reserves the right to add or remove links at its discretion and without prior warning to the operators of the site(s) concerned.
    
    The LTC is under no obligation to comply with requests to add a link to a website or requests by third parties to remove a link to a website.`
  },
  legislation: {
    items: [
      {
        title: "Non-domestic rates legislation",
        links: [
          {
            text: "Non-domestic Rates Legislation",
            url: "https://www.gov.scot/publications/non-domestic-rates-legislation/"
          }
        ]
      },
      {
        title: "Valuation Regulations 2022/2023",
        links: [
          {
            text: "The Valuation (Proposals Procedure) (Scotland) Regulations 2022",
            url: "https://www.legislation.gov.uk/ssi/2022/369/contents/made"
          },
          {
            text: "The Valuation Timetable (Scotland) Order 2022",
            url: "https://www.legislation.gov.uk/ssi/2022/368/contents/made"
          }
        ]
      },
      {
        title: "Council Tax Reduction Regulations",
        links: [
          {
            text: "Council Tax Reduction (Scotland) Regulations 2021",
            url: "https://www.legislation.gov.uk/ssi/2021/249/contents"
          },
          {
            text: "Council Tax Reduction (State Pension Credit) (Scotland) Regulations 2012",
            url: "https://www.legislation.gov.uk/ssi/2012/319/contents"
          }
        ]
      },
      {
        title: "Council Tax Legislation",
        links: [
          {
            text: "Council Tax legislation",
            url: "https://www.gov.scot/publications/council-tax-legislation/"
          },
          {
            text: "The Council Tax (Discounts) (Scotland) Amendment Order 2023",
            url: "https://www.legislation.gov.uk/ssi/2023/25/contents/made"
          }
        ]
      },
      {
        title: "Transfer and Procedure Regulations",
        links: [
          {
            text: "The First-tier Tribunal for Scotland Local Taxation Chamber (Rules of Procedure) Regulations 2022",
            url: "https://www.legislation.gov.uk/ssi/2022/364/contents"
          },
          {
            text: "The First-tier Tribunal for Scotland Local Taxation Chamber and Upper Tribunal for Scotland (Rules of Procedure)(Miscellaneous Amendment Regulations 2023.",
            url: "https://www.legislation.gov.uk/ssi/2023/40/contents/made"
          },
          {
            text: "The First-tier Tribunal for Scotland (Transfer of Functions of the Council Tax Reduction Review Panel) Regulations 2023",
            url: "https://www.legislation.gov.uk/ssi/2023/46/contents/made"
          },
          {
            text: "The First-tier Tribunal for Scotland (Transfer of Functions of Valuation Appeals Committees) Regulations 2023",
            url: "https://www.legislation.gov.uk/ssi/2023/45/contents/made"
          },
          {
            text: "The First-tier Tribunal for Scotland Local Taxation Chamber and Upper Tribunal for Scotland (Composition) Regulations 2023",
            url: "https://www.legislation.gov.uk/ssi/2023/47/contents/made"
          },
          {
            text: "Act of Sederunt (Valuation Appeal Rules Amendment) 2023",
            url: "https://www.legislation.gov.uk/ssi/2023/76/made"
          }
        ]
      }
    ]
  },
  foi: {
    linkTitle: "Scottish Courts and Tribunals website",
    linkUrl: "https://www.scotcourts.gov.uk/about-the-scottish-court-service/contact-us/freedom-of-information"
  },
  hearings: [
    {
      date: "23/06/2023",
      time: "10:00",
      venue: "Glasgow Tribunals Centre, Room 112, 20 York Street, Glasgow, G2 8GT",
      reference: "FTS/HPC/CV/23/0845",
      type: "Oral Hearing",
      appellant: "Forename1 Surname1",
      respondent: "ResponedentForename1 RespondentSurname1"
    },
    {
      date: "24/06/2023",
      time: "11:30",
      venue: "Edinburgh Tribunals Centre, Room 215, 35 Princes Street, Edinburgh, EH2 4PG",
      reference: "FTS/HPC/CV/23/0846",
      type: "Oral Hearing",
      appellant: "Forename2 Surname2",
      respondent: "ResponedentForename2 RespondentSurname2"
    },
    {
      date: "25/06/2023",
      time: "14:15",
      venue: "Aberdeen Tribunals Centre, Room 101, 10 Union Street, Aberdeen, AB10 1QT",
      reference: "FTS/HPC/CV/23/0847",
      type: "Oral Hearing",
      appellant: "Forename3 Surname3",
      respondent: "ResponedentForename3 RespondentSurname3"
    },
    {
      date: "26/06/2023",
      time: "16:45",
      venue: "Dundee Tribunals Centre, Room 307, 5 High Street, Dundee, DD1 1SX",
      reference: "FTS/HPC/CV/23/0848",
      type: "Oral Hearing",
      appellant: "Forename4 Surname4",
      respondent: "ResponedentForename4 RespondentSurname4"
    },
    {
      date: "27/06/2023",
      time: "09:30",
      venue: "Inverness Tribunals Centre, Room 410, 15 Bridge Street, Inverness, IV1 1HG",
      reference: "FTS/HPC/CV/23/0849",
      type: "Oral Hearing",
      appellant: "Forename5 Surname5",
      respondent: "ResponedentForename5 RespondentSurname5"
    },
    {
      date: "28/06/2023",
      time: "13:00",
      venue: "Perth Tribunals Centre, Room 506, 25 King Street, Perth, PH2 2DR",
      reference: "FTS/HPC/CV/23/0850",
      type: "Oral Hearing",
      appellant: "Forename6 Surname6",
      respondent: "ResponedentForename6 RespondentSurname6"
    },
    {
      date: "29/06/2023",
      time: "15:45",
      venue: "Stirling Tribunals Centre, Room 312, 30 Castle Street, Stirling, FK8 1EH",
      reference: "FTS/HPC/CV/23/0851",
      type: "Oral Hearing",
      appellant: "Forename7 Surname7",
      respondent: "ResponedentForename7 RespondentSurname7"
    },
    {
      date: "30/06/2023",
      time: "12:15",
      venue: "Glasgow Tribunals Centre, Room 203, 20 York Street, Glasgow, G2 8GT",
      reference: "FTS/HPC/CV/23/0852",
      type: "Oral Hearing",
      appellant: "Forename8 Surname8",
      respondent: "ResponedentForename8 RespondentSurname8"
    },
    {
      date: "01/07/2023",
      time: "14:30",
      venue: "Edinburgh Tribunals Centre, Room 112, 35 Princes Street, Edinburgh, EH2 4PG",
      reference: "FTS/HPC/CV/23/0853",
      type: "Oral Hearing",
      appellant: "Forename9 Surname9",
      respondent: "ResponedentForename9 RespondentSurname9"
    },
    {
      date: "02/07/2023",
      time: "10:45",
      venue: "Aberdeen Tribunals Centre, Room 315, 10 Union Street, Aberdeen, AB10 1QT",
      reference: "FTS/HPC/CV/23/0854",
      type: "Oral Hearing",
      appellant: "Forename10 Surname10",
      respondent: "ResponedentForename10 RespondentSurname10"
    }
  ]
};

// src/lib/app-data-ltc-members.ts
var LtcMembers = [
  { title: "Mr.", firstName: "James", lastName: "Bauld", type: "Legal" },
  { title: "Mr.", firstName: "Alan", lastName: "Bayley", type: "Legal" },
  { title: "Ms.", firstName: "Louise", lastName: "Carlin", type: "Legal" },
  { title: "Mr.", firstName: "Paul", lastName: "Doyle", type: "Legal" },
  { title: "Mr.", firstName: "Kevin", lastName: "Duffy", type: "Legal" },
  { title: "Mr.", firstName: "Graham", lastName: "Dunlop", type: "Legal" },
  { title: "Mrs.", firstName: "Mary", lastName: "Forbes", type: "Legal" },
  {
    title: "Mr.",
    firstName: "Alastair",
    lastName: "Houston",
    type: "Legal"
  },
  {
    title: "Miss.",
    firstName: "Nicola",
    lastName: "Irvine",
    type: "Legal"
  },
  { title: "Mr.", firstName: "Iain", lastName: "MacRae", type: "Legal" },
  {
    title: "Mrs.",
    firstName: "Elise",
    lastName: "McIntyre",
    type: "Legal"
  },
  {
    title: "Miss.",
    firstName: "Yvonne",
    lastName: "McKenna",
    type: "Legal"
  },
  {
    title: "Mr.",
    firstName: "Andrew",
    lastName: "McLaughlin",
    type: "Legal"
  },
  {
    title: "Mrs.",
    firstName: "Laura",
    lastName: "McLaughlin",
    type: "Legal"
  },
  { title: "Mr.", firstName: "Rick", lastName: "Mill", type: "Legal" },
  { title: "Mrs.", firstName: "Denise", lastName: "Smith", type: "Legal" },
  { title: "Mr.", firstName: "Mark", lastName: "Thorley", type: "Legal" },
  { title: "Mrs.", firstName: "Fiona", lastName: "Watson", type: "Legal" },
  {
    title: "Miss.",
    firstName: "Pamela",
    lastName: "Woodman",
    type: "Legal"
  },
  {
    title: "Mr.",
    firstName: "Alastair",
    lastName: "Hainey",
    type: "Ordinary (Rating Experience)"
  },
  {
    title: "Mrs.",
    firstName: "Sara",
    lastName: "Hesp",
    type: "Ordinary (Rating Experience)"
  },
  {
    title: "Mr.",
    firstName: "David",
    lastName: "Thomson",
    type: "Ordinary (Rating Experience)"
  },
  {
    title: "Mr.",
    firstName: "Donald",
    lastName: "Wooley",
    type: "Ordinary (Rating Experience)"
  },
  {
    title: "Mrs.",
    firstName: "Geraldine",
    lastName: "Wooley",
    type: "Ordinary (Rating Experience)"
  },
  {
    title: "Mr.",
    firstName: "Nicholas",
    lastName: "Allan",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Mr.",
    firstName: "Gordon",
    lastName: "Anderson",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Mrs.",
    firstName: "Alison",
    lastName: "Blaney",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Mr.",
    firstName: "Kingsley",
    lastName: "Bruce",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Mr.",
    firstName: "Gavin",
    lastName: "Falconer",
    type: "Ordinary (Rating Experience)"
  },
  {
    title: "Mr.",
    firstName: "John",
    lastName: "Flynn",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Mr.",
    firstName: "David",
    lastName: "Godfrey",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Mrs.",
    firstName: "Patricia",
    lastName: "Marshall",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Mr.",
    firstName: "Peter",
    lastName: "McEachran",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Mr.",
    firstName: "John",
    lastName: "McNaught",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Mr.",
    firstName: "Ross",
    lastName: "Milligan",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Mr.",
    firstName: "Paul",
    lastName: "Walker",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Mr.",
    firstName: "Robert",
    lastName: "Walsh",
    type: "Ordinary (Valuation Experience)"
  },
  {
    title: "Ms.",
    firstName: "Sheena",
    lastName: "West",
    type: "Ordinary (Valuation Experience)"
  }
];

// src/lib/app-data-ltc-process-steps.ts
var AppDataProcessSteps = {
  ndrBanding: {
    steps: [
      {
        step: 1,
        title: "Understand what an appeal involves",
        body: `To make an appeal you\u2019ll first need to complete an appeal form  and provide the required information. You\u2019ll find details on how to do this below. If you want to appeal, you must do it within the following time limits:
        
        Time limits for making Appeals:

If the Assessor has issued a Notice of a Decision in respect of a Proposal an appeal must be made to the Local Taxation Chamber within 28 days of the date of receipt of that Notice of Decision. 

If the Assessor has issued a Proposal Determination date in relation to a Proposal but no Notice of Decision has been provided an appeal must be made to the Local Taxation Chamber within 28 days of the Proposal Determination date.

If a Proposal Determination date in relation to a Proposal has not been issued 70 days before the later of (i) 30th September 2025; (ii) 30th September in the year after the proposal is made to the Assessor and (iii) 12 months after the date the Proposal is made to the Assessor, an appeal must be made to the Local Taxation Chamber no later than 42 days before that date.
        `
      },
      {
        step: 2,
        title: "What can I appeal?",
        body: `You can appeal if:

        The Assessor has issued a Decision in response to your Proposal and the decision is either not to amend the Valuation Roll or to amend the Valuation Roll to an entry other than that detailed in your Proposal and you do not agree with the Assessor\u2019s decision.  

        The Assessor has issued a Proposal Determination Date but has not issued a Decision by the Proposal Determination Date.

        If a Proposal Determination date in relation to your Proposal has not been issued 70 days before the later of (i) 30th September 2025; (ii) 30th September in the year after the Proposal is made to the Assessor and (iii) 12 months after the date your Proposal is made to the Assessor.
         `
      },
      {
        step: 3,
        title: "Complete the appeal form",
        body: `If you want to appeal, please read the guidance note above and complete the appeal form. N.B Appeals should only be lodged with information that was shared with the Assessor at the Proposals stage.  `
      },
      {
        step: 4,
        title: "Appeal registration",
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`
      },
      {
        step: 5,
        title: "Attend the hearing",
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one or two ordinary members with valuation and/ or rating experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision. 
        
        During the hearing: 
        The Tribunal will ask you and the Assessor to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, and we will try put everyone at ease. However, these are judicial proceedings, so there is some formality.`
      }
    ]
  },
  ndrComplaint: {
    steps: [
      {
        step: 1,
        title: "Understand what an appeal involves",
        body: `To make a complaint relating to an entry in the 2023 Valuation Roll you will first need to complete an application form  and provide the required information. You will find details on how to do this below. The application must be submitted to the Local Taxation Chamber by 31st July 2023. `
      },
      {
        step: 2,
        title: "What can I appeal?",
        body: `
        There are four types of Complaint:

    Complaint that the yearly rent or value of any lands or heritages in the current valuation is not the correct amount (Section 13 of the Lands Valuation (Scotland) Act 1854).

    Complaint that details other than valuation are incorrect (Section 6 of the Valuation of Lands (Scotland) Amendment Act 1879).

    Complaint that particular subjects are not included in the valuation roll (Section 22 of the Local Government (Scotland) Act 1966).

    Lands and heritages consisting of a pitch for a caravan should be separately entered in the valuation roll (Section 3(1) of the rating (Caravan Sites) Act 1976).
`
      },
      {
        step: 3,
        title: "Complete the appeal form",
        body: `If you want to appeal, please read the guidance note above and complete the appeal form. Once completed send it to the Local Taxation Chamber ( the details are provided on the application form).`
      },
      {
        step: 4,
        title: "Appeal registration",
        body: `We will check your application form and register the Complaint if we have all the information. We aim to register Complaints within 14 days of receiving them. We will let you know when the Complaint is registered. If we cannot register the Complaint, we will let you know why.`
      },
      {
        step: 5,
        title: "Attend the hearing",
        body: `Complaints are decided by the Tribunal at the hearing. The Tribunal will comprise one legal member and one or two ordinary members with valuation and/ or rating experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision. 
        
        During the hearing: 
        The Tribunal will ask you and the Assessor to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, and we will try put everyone at ease. However, these are judicial proceedings, so there is some formality.`
      }
    ]
  },
  ndrPenalty: {
    steps: [
      {
        step: 1,
        title: "Understand what an appeal involves",
        body: `To make an appeal you\u2019ll first need to read the Guidance Note, complete an appeal form and provide information and evidence to support your case. If you want to appeal, you must do it within twenty eight days of the date the penalty notice was sent to you.`
      },
      {
        step: 2,
        title: "What can I appeal?",
        body: `You can appeal the imposition of a penalty in terms of an Assessor Penalty Notice; the amount of a penalty imposed by a Local authority Notice for failure to comply with a Local Authority Information Notice and failure to notify a change in circumstances.`
      },
      {
        step: 3,
        title: "Complete the appeal form",
        body: `If you want to appeal, please read the guidance note above and complete the appeal form. Once completed send it to the Local Taxation Chamber ( the details are provided on the application form).`
      },
      {
        step: 4,
        title: "Appeal registration",
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`
      },
      {
        step: 5,
        title: "Preparation for the Hearing",
        body: `You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing. `
      },
      {
        step: 6,
        title: "Attend the hearing",
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one ordinary member with valuation experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision. 
        
        During the hearing: 
        The Tribunal will ask you and the assessor or local authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, and we will try put everyone at ease. However, these are judicial proceedings, so there is some formality.`
      }
    ]
  },
  ctLiability: {
    steps: [
      {
        step: 1,
        title: "Understand what an appeal involves",
        body: `To make an appeal you\u2019ll first need to read the Guidance Note, complete an appeal form and provide information and evidence to support your case. If you want to appeal, you must do it within four months of your appeal to the Local Authority.`
      },
      {
        step: 2,
        title: "What can I appeal?",
        body: `You can appeal if you think your council tax liability calculation is wrong and/ or the incorrect discounts and /or exemptions have been applied.`
      },
      {
        step: 3,
        title: "Complete the appeal form",
        body: `If you want to appeal, please read the guidance note above and complete the appeal form. Once completed send it to the Local Taxation Chamber ( the details are provided on the application form).`
      },
      {
        step: 4,
        title: "Appeal registration",
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`
      },
      {
        step: 5,
        title: "Preparation for the Hearing",
        body: `You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing. `
      },
      {
        step: 6,
        title: "Attend the hearing",
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision. 
        
        During the hearing: 
        The Tribunal will ask you and the representative from the local authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, and we will try put everyone at ease. However, these are judicial proceedings, so there is some formality.`
      }
    ]
  },
  ctCompletion: {
    steps: [
      {
        step: 1,
        title: "Understand what an appeal involves",
        body: `To make an appeal you\u2019ll first need to complete an appeal form and provide information and evidence to support your case. You\u2019ll find details on how to do this below. If you want to appeal, you must do it within 21 days of the date you received the completion notice.`
      },
      {
        step: 2,
        title: "What can I appeal?",
        body: `You can appeal if you disagree with the date on a completion notice.`
      },
      {
        step: 3,
        title: "Complete the appeal form",
        body: `If you want to appeal, please read the guidance note above and complete the appeal form. Once completed send it to the Local Taxation Chamber ( the details are provided on the application form).`
      },
      {
        step: 4,
        title: "Appeal registration",
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`
      },
      {
        step: 5,
        title: "Preparation for the Hearing",
        body: `If  you disagree with the completion date in the Completion Notice you must provide evidence to support the date that you consider to be the correct date. `
      },
      {
        step: 6,
        title: "Attend the hearing",
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one ordinary member with valuation experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision. 
        
        During the hearing: 
        The Tribunal will ask you and the assessor to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, and we will try put everyone at ease. However, these are judicial proceedings, so there is some formality.`
      }
    ]
  },
  ctBandingInValid: {
    steps: [
      {
        step: 1,
        title: "Understand what an appeal involves",
        body: `To make an appeal you\u2019ll first need to read the Guidance Note, complete an appeal form and provide information and evidence to support your case. If you want to appeal, you must do it within 28 days of the date you received the Notice stating that your appeal was invalid.`
      },
      {
        step: 2,
        title: "What can I appeal?",
        body: `You can appeal if you disagree with the Assessor\u2019s decision that your Proposal was invalid.`
      },
      {
        step: 3,
        title: "Complete the appeal form",
        body: `If you want to appeal, please complete an appeal form. In the appeal form you should explain why you think the Assessor\u2019s decision is wrong.`
      },
      {
        step: 4,
        title: "Appeal registration",
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`
      },
      {
        step: 5,
        title: "Appeals are determined by the Tribunal without a hearing based on your written representations. ",
        body: `Appeals are decided by the Tribunal which will consist of one legal member. The legal member will consider the parties written representations and reach a decision. You will be provided with the Tribunal\u2019s written decision in due course.  `
      }
    ]
  },
  ctReduction: {
    steps: [
      {
        step: 1,
        title: "Understand what an appeal involves",
        body: `To make an appeal you\u2019ll first need to read the Guidance Note, complete an appeal form and provide information and evidence to support your case. `
      },
      {
        step: 2,
        title: "What can I appeal?",
        body: `You can appeal if you are aggrieved by a determination in relation to your council tax reduction application, but only AFTER you have applied to the Local Authority for a review of their initial determination..`
      },
      {
        step: 3,
        title: "Complete the appeal form",
        body: `If you want to appeal, please read the guidance note above and complete the appeal form. Once completed send it to the Local Taxation Chamber ( the details are provided on the application form).`
      },
      {
        step: 4,
        title: "Appeal registration",
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`
      },
      {
        step: 5,
        title: "Preparation for the Hearing",
        body: `You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing. `
      },
      {
        step: 6,
        title: "Attend the hearing",
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision. 
        
        During the hearing: 
        The Tribunal will ask you and the representative from the Local Authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, and we will try put everyone at ease. However, these are judicial proceedings, so there is some formality.`
      }
    ]
  },
  ctWater: {
    steps: [
      {
        step: 1,
        title: "Understand what an appeal involves",
        body: `To make an appeal you\u2019ll first need to complete an appeal form and provide information and evidence to support your case. You\u2019ll find details on how to do this below. If you want to appeal, you must do it within four months of your notice to the Local Authority that you are aggrieved by their decision.`
      },
      {
        step: 2,
        title: "What can I appeal?",
        body: `You can appeal:
        A Decision that a dwelling is a chargeable dwelling, or that you are liable to pay Water Charges, Water Services Charges or Sewerage Charges for the dwelling or any calculation of an amount of Water Charges, Water Service Charges or Sewerage Charges you are liable to pay
        `
      },
      {
        step: 3,
        title: "Complete the appeal form",
        body: `If you want to appeal, please read the guidance note above and complete the appeal form. Once completed send it to the Local Taxation Chamber ( the details are provided on the application form).`
      },
      {
        step: 4,
        title: "Appeal registration",
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`
      },
      {
        step: 5,
        title: "Attend the hearing",
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one ordinary member with valuation experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision. 
        
        During the hearing: 
        The Tribunal will ask you and the representative from the local authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, and we will try put everyone at ease. However, these are judicial proceedings, so there is some formality.`
      }
    ]
  },
  ctPenalty: {
    steps: [
      {
        step: 1,
        title: "Understand what an appeal involves",
        body: `To make an appeal you\u2019ll first need to complete an appeal form and provide information and evidence to support your case. You\u2019ll find details on how to do this below. If you want to appeal, you must do it within two months of the date on which the penalty was imposed.`
      },
      {
        step: 2,
        title: "What can I appeal?",
        body: `You can appeal if you are :

        aggrieved by a Penalty for failing to supply information or knowingly providing inaccurate information;

        aggrieved by Penalty for failing to notify the local authority;

        aggrieved by a Penalty for acts or omissions that resulted in an exemption or reduction you were not entitled to or you allege there is no power in the case for the Local Authority to impose the penalty.
`
      },
      {
        step: 3,
        title: "Complete the appeal form",
        body: `If you want to appeal, please read the guidance note above and complete the appeal form. Once completed send it to the Local Taxation Chamber ( the details are provided on the application form).`
      },
      {
        step: 4,
        title: "Appeal registration",
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`
      },
      {
        step: 5,
        title: "Preparation for the Hearing",
        body: `You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing. 
        `
      },
      {
        step: 6,
        title: "Attend the hearing",
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one ordinary member with valuation experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision. 
        
        During the hearing: 
        The Tribunal will ask you and the local authority to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, and we will try put everyone at ease. However, these are judicial proceedings, so there is some formality.`
      }
    ]
  },
  ctBanding: {
    steps: [
      {
        step: 1,
        title: "Understand what an appeal involves",
        body: `For your appeal to be a valid appeal you must have sent your Proposal to alter the council tax band to the Assessor within six months of the date you became liable to pay council tax for the Property. If you sent your Proposal to the Assessor after this date your Proposal will be invalid.  ( refer to separate section of the website).
        
        To make an appeal you\u2019ll first need to complete an appeal form and provide information and evidence to support your case. You\u2019ll find details on how to do this below. If you want to appeal, you must do it within 12 weeks of the date the Proposal to alter the band was served on the assessor. `
      },
      {
        step: 2,
        title: "What can I appeal?",
        body: `You can appeal if you think your property is in the wrong council tax band. `
      },
      {
        step: 3,
        title: "Complete the appeal form",
        body: `If you want to appeal, please read the guidance note above and complete the appeal form. Once completed send it to the Local Taxation Chamber ( the details are provided on the application form).`
      },
      {
        step: 4,
        title: "Appeal registration",
        body: `We will check your appeal form and register the appeal if we have all the information. We aim to register appeals within 14 days of receiving them. We will let you know when the appeal is registered. If we cannot register the appeal, we will let you know why.`
      },
      {
        step: 5,
        title: "Preparation for the Hearing",
        body: `If you propose to inform the Tribunal that the valuation band of your property does not compare fairly with the bands placed on other properties then it will be advisable to tell the Assessor the properties to which you will be referring. You must also provide the Tribunal with any documents you wish to refer to at least 14 days before the hearing. 

        The Council Tax Bands are as follows. Note the valuation date is 1st April 1991.
        
        Values not exceeding \xA327,000                                                                     A
        Values exceeding \xA327,000 but not exceeding \xA335,000                                               B
        Values exceeding \xA335,000 but not exceeding \xA345,000                                               C
        Values exceeding \xA345,000 but not exceeding \xA358,000                                               D
        Values exceeding \xA358,000 but not exceeding \xA380,000                                               E
        Values exceeding \xA380,000 but not exceeding \xA3106,000                                              F
        Values exceeding \xA3106,000 but not exceeding \xA3212,000                                             G
        Values exceeding \xA3212,000                                                                        H
        `
      },
      {
        step: 6,
        title: "Attend the hearing",
        body: `Appeals are decided by the Tribunal at the appeal hearing. The Tribunal will comprise one legal member and one ordinary member with valuation experience. Hearings are conducted remotely using online/audio visual conferencing software. The Tribunal is impartial and independent. The Tribunal will listen to both sides before making a decision. 
        
        During the hearing: 
        The Tribunal will ask you and the assessor to present your cases. You will be able to ask questions. You may be asked questions. We try to make the hearing as informal as we can, and we will try put everyone at ease. However, these are judicial proceedings, so there is some formality.`
      }
    ]
  }
};
export {
  AppData,
  AppDataLocalTax,
  AppDataProcessSteps,
  LtcMembers
};
